import styled from "styled-components";

export const Wrapper = styled.div`
    .avaiable-user-proto {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: ${props => props.isSmall ? "0 10px" : "10px"};
        ${props => props.isSmall ? "" : "gap: 10px;"}
        cursor: pointer;
    
        .img-box {
            display: flex;
            justify-content: center;
            align-items: center;
            height: ${props => props.isSmall ? "40px" : "50px"};
            width: ${props => props.isSmall ? "40px" : "50px"};
            background: white;
            border-radius: 5px;

            img {
                height: ${props => props.isSmall ? "35px" : "45px"};
                width: ${props => props.isSmall ? "35px" : "45px"};
            }
        }

        .nameuser {
            font-size: 10px;
            color: ${props => props.isDragging ? "black" : "white"};
            font-weight: ${props => props.isSmall ? "600" : "500"};
            text-transform: ${props => props.isSmall ? "uppercase" : "Captialize"};
            ${props => props.isSmall ? `
                width: 71px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            `: ""}
        }
    }
`